import { useSubscription } from "@apollo/client";
import USERS_SUBSCRIPTION from "../../subscriptions/users";
import { useDispatch } from "react-redux";
import { useMemo } from "react";
import { applySubEvent } from "../../state/ducks/docSubscriptions";

export const shouldApplySubEvent = (payload, currentUserId) => {
  if (!payload) return false;

  const isCurrentUserSubscription =
    payload.subscriptionType === "USER_SUBSCRIPTIONS" &&
    payload.action === "subscribed" &&
    String(payload.userId) === String(currentUserId);

  return !isCurrentUserSubscription;
};

export const handleSubEvent = ({ payload, userId, dispatch }) => {
  if (!shouldApplySubEvent(payload, userId)) return;

  dispatch(applySubEvent(payload));
};

const UserSubs = ({ clientId, userId }) => {
  const dispatch = useDispatch();

  const config = useMemo(
    () => ({
      variables: { clientId },
      onSubscriptionData: ({ subscriptionData }) => {
        const payload = subscriptionData?.data?.userSubscriptions;
        handleSubEvent({
          payload,
          userId,
          dispatch,
        });
      },

      onError: (e) => console.error("UserSubs error", e),
    }),
    [clientId, dispatch, userId]
  );

  useSubscription(USERS_SUBSCRIPTION, config);
  return null;
};

export default UserSubs;
